/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function RadarIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="radar"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M21.012 15.004A9.5 9.5 0 0 1 2.513 11.501" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 9.5 9.5 18.435 183.013 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 12L12 1.5L12.5 1.5C18.023 1.5 22.5 5.977 22.5 11.5L22.5 12L12 12Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M9.232 17.323A6 6 0 0 1 8.913 6.855" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 6 6 117.474 239.036 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 12L12 12" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(266.667)} data-tinysvg-stroke-width="266.667" />
          <path d="M12 18L12 18" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(133.333)} data-tinysvg-stroke-width="133.333" />
          <path d="M3.08 8.73L3.08 8.73" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(133.333)} data-tinysvg-stroke-width="133.333" />
          <path d="M17.145 15.087A6 6 0 0 1 14.724 17.346" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 6 6 30.964 62.999 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M4.402 6.297A9.5 9.5 0 0 1 8.996 2.988" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 9.5 9.5 216.894 251.565 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
